// extracted by mini-css-extract-plugin
export default {"layout_test":"index_layout_test_vMJYC","main":"index_main_TSqsm","container":"index_container_ge3K-","colLeft":"index_colLeft_aZVz1","colRight":"index_colRight_k5vnF"};